var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAttendanceOverallPercentage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 30,
    viewBox: "0 0 31 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.3739 15.8802C25.9008 15.4071 25.1384 15.4071 24.6653 15.8802L16.5423 24.0032C16.0692 24.4763 16.0692 25.2387 16.5423 25.7118C16.7789 25.9483 17.0945 26.0536 17.4098 26.0536C17.7252 26.0536 18.0408 25.9485 18.2773 25.7118L26.4003 17.5888C26.8471 17.1157 26.8472 16.3535 26.3739 15.8802Z",
    fill: "#805AD5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6463 17.0107C19.6463 18.0995 18.7636 18.9822 17.6747 18.9822C16.5859 18.9822 15.7031 18.0995 15.7031 17.0107C15.7031 15.9216 16.5859 15.0391 17.6747 15.0391C18.7636 15.0391 19.6463 15.9216 19.6463 17.0107Z",
    fill: "#805AD5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.2166 24.581C27.2166 25.6698 26.3339 26.5526 25.245 26.5526C24.1562 26.5526 23.2734 25.6698 23.2734 24.581C23.2734 23.4921 24.1562 22.6094 25.245 22.6094C26.3339 22.6094 27.2166 23.4921 27.2166 24.581Z",
    fill: "#805AD5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9862 12.6209L20.5908 10.9911C20.7223 10.6493 20.4593 10.2812 20.0913 10.2812H8.62979C6.78968 10.2812 5.26494 11.6483 5.08083 13.4884L4.60774 17.8522C4.55511 18.2729 4.84429 18.6671 5.26494 18.7724C5.73802 18.8775 6.36903 18.9565 6.99998 19.0353L7.39423 25.9753C7.42045 26.5537 7.91994 27.0006 8.49832 27.0006H11.8369C12.4153 27.0006 12.8883 26.5537 12.941 25.9753L13.5458 14.0406C13.5458 13.4361 14.0453 12.9628 14.6236 12.9628H19.4869C19.7233 12.9628 19.9074 12.8313 19.9862 12.621L19.9862 12.6209Z",
    fill: "#805AD5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8627 5.65402C13.8627 7.67199 12.2267 9.30803 10.2087 9.30803C8.19055 9.30803 6.55469 7.67199 6.55469 5.65402C6.55469 3.63605 8.19055 2 10.2087 2C12.2267 2 13.8627 3.63605 13.8627 5.65402Z",
    fill: "#805AD5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttendanceOverallPercentage);
export default __webpack_public_path__ + "static/media/AttendanceOverallPercentage.39169e6370625b09513694a8a87d561a.svg";
export { ForwardRef as ReactComponent };